'use client'
import { useEffect, useState, memo } from 'react'

// 用于仅仅渲染客户端组件，避免在服务端被渲染导致水合报错组件，如计时器组件，无需在服务端渲染。
export default function withClientComponent<TClientComponentProps>(
  Component: React.ComponentType<TClientComponentProps>,
  fallback?: React.ReactNode
) {
  return function ClientComponent(props: TClientComponentProps) {
    const [isClient, setIsClient] = useState(false)
    const MemoComponent = memo(Component)
    useEffect(() => {
      if (typeof window !== 'undefined') {
        setIsClient(true)
      }
    }, [])
    return isClient ? <MemoComponent {...props} /> : fallback || null
  }
}
